import React, { useContext } from "react";
import PropTypes from "prop-types";
import { MobileContext } from "components/common";
import Dropdown from "./Dropdown";
import States from "./ui/States";

const propTypes = {
  didSelect: PropTypes.func,
  disabled: PropTypes.bool,
};

const defaultProps = {
  didSelect: () => {},
  disabled: false,
};

const states = [
  { value: "AL", name: "Alabama" },
  { value: "AK", name: "Alaska" },
  { value: "AZ", name: "Arizona" },
  { value: "AR", name: "Arkansas" },
  { value: "CA", name: "California" },
  { value: "CO", name: "Colorado" },
  { value: "CT", name: "Connecticut" },
  { value: "DE", name: "Delaware" },
  { value: "DC", name: "District Of Columbia" },
  { value: "FL", name: "Florida" },
  { value: "GA", name: "Georgia" },
  { value: "HI", name: "Hawaii" },
  { value: "ID", name: "Idaho" },
  { value: "IL", name: "Illinois" },
  { value: "IN", name: "Indiana" },
  { value: "IA", name: "Iowa" },
  { value: "KS", name: "Kansas" },
  { value: "KY", name: "Kentucky" },
  { value: "LA", name: "Louisiana" },
  { value: "ME", name: "Maine" },
  { value: "MD", name: "Maryland" },
  { value: "MA", name: "Massachusetts" },
  { value: "MI", name: "Michigan" },
  { value: "MN", name: "Minnesota" },
  { value: "MS", name: "Mississippi" },
  { value: "MO", name: "Missouri" },
  { value: "MT", name: "Montana" },
  { value: "NE", name: "Nebraska" },
  { value: "NV", name: "Nevada" },
  { value: "NH", name: "New Hampshire" },
  { value: "NJ", name: "New Jersey" },
  { value: "NM", name: "New Mexico" },
  { value: "NY", name: "New York" },
  { value: "NC", name: "North Carolina" },
  { value: "ND", name: "North Dakota" },
  { value: "OH", name: "Ohio" },
  { value: "OK", name: "Oklahoma" },
  { value: "OR", name: "Oregon" },
  { value: "PA", name: "Pennsylvania" },
  { value: "RI", name: "Rhode Island" },
  { value: "SC", name: "South Carolina" },
  { value: "SD", name: "South Dakota" },
  { value: "TN", name: "Tennessee" },
  { value: "TX", name: "Texas" },
  { value: "UT", name: "Utah" },
  { value: "VT", name: "Vermont" },
  { value: "VA", name: "Virginia" },
  { value: "WA", name: "Washington" },
  { value: "WV", name: "West Virginia" },
  { value: "WI", name: "Wisconsin" },
  { value: "WY", name: "Wyoming" },
];

const StatesDropdown = ({
  didSelect,
  disabled,
  defaultValue,
  SettingsInputContainer,
  desktopOnly = false,
  dropdownStyle,
}) => {
  const { isMobile } = useContext(MobileContext);
  return isMobile && !desktopOnly ? (
    <SettingsInputContainer style={{ paddingTop: 0, paddingBottom: 0 }}>
      <States
        onSelect={didSelect}
        disabled={disabled}
        className="w-full bg-white"
        style={{
          "height": "3.5rem",
          "outline": "none",
          "-webkit-appearance": "none",
        }}
        value={defaultValue}
      />
    </SettingsInputContainer>
  ) : (
    <Dropdown
      elements={states}
      disabled={disabled}
      component={(e) => (e ? <div className="py-2">{e.name}</div> : <></>)}
      selectedElement={
        defaultValue
          ? states
            .filter((s) => s.value === defaultValue || s.name === defaultValue)
            .pop() || null
          : null
      }
      didSelect={didSelect}
      style={dropdownStyle}
    />
  );
};

StatesDropdown.propTypes = propTypes;
StatesDropdown.defaultProps = defaultProps;

export default StatesDropdown;
